export default __webpack_public_path__ + "static/media/Designer-9.51aab80e.png";